import { Pipe, PipeTransform } from '@angular/core';

import { Fai, ProductFactory, Subscription } from '@bytel/bytel-sales';
import { CommercialSeries } from '@bytel/checkout';

@Pipe({
    name: 'isTabletRange',
    standalone: true,
})
export class TabletPipe implements PipeTransform {
    transform(plan: Subscription): boolean {
        if (plan && ProductFactory.Is(plan, Fai)) {
            return plan.data.commercial_series === CommercialSeries.TABLETTE;
        } else {
            return false;
        }
    }
}
